// extracted by mini-css-extract-plugin
export default {"externalLinkWrapper":"IKdGPU","externalLinksList":"gzD_rQ"};